/**
 * Builds the shared grouped-control CSS classes for a consumer.
 *
 * Returns an empty list when the control is not in a group (falsy `position`),
 * otherwise the `grouped` base class plus the position/direction modifier.
 * Spread the result into `clsx(...)` at the call site.
 */
export function getGroupedControlClassNames(styles, { position, direction, endAction }) {
    if (!position) {
        return [];
    }
    const classNames = [styles.grouped, styles[`grouped-${direction}-${position}`]];
    // When an action is fused onto the group's inline-end, square the control's corners
    // that face the action (see the grouped-control `-end-action` rules in the mixin).
    if (endAction) {
        classNames.push(styles[`grouped-end-action-${direction}-${position}`]);
    }
    return classNames;
}
//# sourceMappingURL=grouped-control-styles.js.map